import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(VForm,{model:{value:(_vm.isValid),callback:function ($$v) {_vm.isValid=$$v},expression:"isValid"}},_vm._l((_vm.variables),function(jvar){return _c(VTextField,{attrs:{"outlined":"","dense":"","label":jvar.name,"rules":_vm.varRule},model:{value:(jvar.value),callback:function ($$v) {_vm.$set(jvar, "value", $$v)},expression:"jvar.value"}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }